export default __webpack_public_path__ + "static/media/people-3.02fe3b62.jpg";